<template>
	<div class="info-item">
		<div style="padding-bottom: 5px;display: flex;align-items: center;">
			<el-divider direction="vertical"></el-divider>
			<span>{{title}}</span>
		</div>
		<div class="form-box" v-if="form">
           <el-table :data="form" size="mini" border :header-cell-style="headerCellStyle">
                <el-table-column prop="code" label="分类编码"></el-table-column>
                <el-table-column prop="name" label="分类名称"></el-table-column>
            </el-table>
		</div>
		<div v-else class="no-info-box">请补充相关信息</div>
	</div>
</template>

<script>
	export default {
		name: "ShowBankInfo",
		computed: {
			currencyInfo:function(){
				return this.$store.getters['app/currencyInfo'];
			},
		},
		props:['title','form'],
		data() {
			return {
				imgHost:process.env.VUE_APP_BASE_API,
				tableData: [],
			};
		},
		mounted() {
		},
		methods: {
            formatIsMainNum: function(row) {
				return row.isMainNum == 0 ? '是' : '否';
			},
		}
	};
</script>
<style scoped="scoped">
</style>